import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';
import { MaintVehicle } from './vehMaintenance.model';
import { Observable } from 'rxjs'

@Injectable()
export class VehMaintenanceService {
    public pushID: any;
    vehMaintDocCol: AngularFirestoreCollection<MaintVehicle>;
    vehMaintDoc: AngularFirestoreDocument<MaintVehicle>;
    vehStatusCol: AngularFirestoreCollection<MaintVehicle>;
    vehStatusDoc: AngularFirestoreDocument<MaintVehicle>;
    vehiclesMaint: Observable<MaintVehicle[]>

    maintItems: Observable<MaintVehicle[]>;

    maintItemsStatus: Observable<MaintVehicle[]>;

    constructor(public afs: AngularFirestore) {
        this.vehMaintDocCol = this.afs.collection('Maintenance');
        this.vehStatusCol = this.afs.collection('VeicleStatus')

        // this.vehiclesMaint = this.vehMaintDocCol.snapshotChanges().map(changes => {
        //     return changes.map(a => {
        //         const data = a.payload.doc.data() as MaintVehicle;
        //         data.id = a.payload.doc.id;
        //         return data;
        //     });
        // });

        this.maintItems = this.afs.collection('Maintenance').valueChanges();
    }
    addVehMaintDoc(veh: MaintVehicle) {
        veh.push_id = this.afs.createId();
        this.vehMaintDoc = this.afs.collection('Maintenance').doc(veh.push_id);
        this.vehMaintDoc.set(veh)
        // console.log(veh.push_id)
        // console.log(veh)

        // veh.push_id = this.afs.createId();
        // this.vehStatusDoc = this.afs.collection('VeicleStatus').doc(veh.vehId).collection(date).doc(veh.push_id);
        // this.vehStatusDoc.set(veh)
        // console.log(veh.push_id)
        // console.log(veh)
    }

    addVehStatusDoc(status, date) {
        status.push_id = this.afs.createId();
        this.vehStatusDoc = this.afs.collection('VeicleStatus').doc(status.vehId).collection(date).doc(status.push_id);
        this.vehStatusDoc.set(status)
        // console.log(status.push_id)
        // console.log(status)
    }

    getDocStatus(obj) {
        this.maintItems = this.afs.collection('Maintenance', ref => ref
            // .where('statusDate', '==', obj.statusDate)
            .where('Status', '==', obj.Status)
            .where('stage', '==', obj.stage)
            .where('tab_position', '==', obj.tab_position)
            .where('request_status', '==', obj.request_status)
            .where('prjid', '==', obj.prjid).where('vehId', '==', obj.vehId))
            .valueChanges();
        // console.log("para", obj)
        return this.maintItems
    };
}


// WEBPACK FOOTER //
// ./src/app/maintenance/vehicleMaintenance/vehicleMnt/vehMaintenance.service.ts